/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  inline: {
    background: '#FFF',
    '& .trigger': {
      '&.CONTROL_BAR': {
        width: pxToEm(80),
        display: 'flex',
        '&.TOP_ALIGNMENT': {
          alignItems: 'flex-start !important'
        },
        '&.MIDDLE_ALIGNMENT': {
          alignItems: 'center !important'
        },
        '&.BOTTOM_ALIGNMENT': {
          alignItems: 'flex-end !important',
          '& .inlinecontainer': {
            margin: '0 auto'
          }
        },
        '&.LEFT_EDGE_PLACEMENT': {
          justifyContent: 'flex-start !important'
        },
        '&.RIGHT_EDGE_PLACEMENT': {
          justifyContent: 'flex-end !important'
        },
        '&.BOTTOM_PLACEMENT': {
          width: '100%',
          '& > div': {
            width: '100%'
          },
          alignItems: 'flex-end !important'
        }
      }
    },
    '& .button': {
      background: '#FFF',
      boxShadow: '0px 0px 3.92px 0px rgba(0, 0, 0, 0.06)',
      borderRadius: pxToEm(26),
      height: pxToEm(24),
      padding: `${pxToEm(16)} ${pxToEm(24)}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 600,
    },
    '& .buttonclickicon': {
      position: 'relative',
      top: '-6px',
      right: '-72px'
    },
    '& .inlinecontainer': {
      padding: '24px 0',
      width: '100%',
      height: '100%',
      minHeight: pxToEm(400),
      maxWidth: pxToEm(400),
      minWidth: pxToEm(300),
      background: '#FFF',
      zIndex: 10,
      '&.BUTTON, &.CUSTOM, &.NONE': {
        margin: '0 auto',
      },
      '&.NONE': {
        padding: '24px'
      },
      margin: pxToEm(16),
      '& .trendingnow': {
        width: '100%',
        '& .articlecard.vertical': {
          minWidth: pxToEm(84)
        }
      }
    },
    '& .controlbar': {
      position: 'relative',
      top: 0,
      left: 0
    }
  }
});
